import { z } from 'zod'
import type { TimelinePost } from '@/types/post'

export const editPostFormSchema = z.object({
  territories: z.array(z.string()).min(1, 'Territórios é obrigatório'),
  topics: z.array(z.string()).optional(),
  contexts: z.array(z.string()).optional(),
  type: z.enum(['COMMUNITY', 'CREATOR', 'FORMAT', 'TREND', 'AESTHETIC', 'SUBJECT']).optional(),
  partners: z.array(z.string()).optional(),
})

export type EditPostFormData = z.infer<typeof editPostFormSchema>

export interface EditPostModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  post: TimelinePost
  onSuccess: (updatedPost: TimelinePost) => void
}
